<template>
  <v-container class="px-1">
      <v-form ref="filterPgtosEmProcessamentoForm">
      <v-row>
          <v-col class="py-0 px-2" cols="2">
            <label>Data de</label>
            <v-menu
                ref="dtI"
                v-model="dtI"
                :close-on-content-click="true"
                transition="scale-transition"
                offset-y
            >
                <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="dateIFormatted"
                    dense
                    v-mask="'##/##/####'"
                    format="DD/MM/YYYY"
                    placeholder="DD/MM/YYYY"
                    label
                    outlined
                    v-bind="attrs"
                    v-on="on"
                    append-icon="mdi-calendar-blank"
                    @blur="dateI = parseDate(dateIFormatted)"
                    :rules="[formRules.typeDateFormated]"
                ></v-text-field>
                </template>
                <v-date-picker color="primary"  v-model="dateI" no-title scrollable></v-date-picker>
            </v-menu>
          </v-col>
          <v-col class="py-0 px-2" cols="2">
            <label>até</label>
            <v-menu
                ref="dtF"
                v-model="dtF"
                :close-on-content-click="true"
                transition="scale-transition"
                offset-y
            >
                <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="dateFFormatted"
                    v-mask="'##/##/####'"
                    format="DD/MM/YYYY"
                    placeholder="DD/MM/YYYY"
                    label
                    dense
                    outlined
                    v-bind="attrs"
                    v-on="on"
                    append-icon="mdi-calendar-blank"
                    @blur="dateF = parseDate(dateFFormatted)"
                    :rules="[formRules.typeDateFormated]"
                ></v-text-field>
                </template>
                <v-date-picker color="primary"  v-model="dateF" no-title scrollable></v-date-picker>
            </v-menu>
          </v-col>
          <v-col class="py-0 px-2" cols="2">
            <label>SLA</label>
            <v-select
                v-model="formData.qtd_dias"
                :items="statusFilter"
                item-value="id"
                item-text="descricao"
                :menu-props="{ bottom: true, offsetY: true }"
                flat
                solo
                dense
                outlined
            ></v-select>
          </v-col>
          <v-spacer></v-spacer>
          <v-col class="py-0 pl-2 pr-0" cols="3">
           <v-switch
            v-model="formData.com_intercorrencia"
            :label="'Apenas com intercorrências'"
            color="error"
            class="mr-0"
            ></v-switch>
          </v-col>
      </v-row>
      <v-row>
          <v-col cols="12" sm="6" md="3" class="px-3 py-0">
            <label>Prestador</label>
            <v-autocomplete
              v-model="formData.prestador_id"
              :items="prestadoresFilter"
              item-value="id"
              item-text="prest_nome"
              label="Selecione"
              multiple
              chips
              outlined
              flat
              solo
              dense
              filled
              :disabled="prestadoresFilter.length==1"
              :search-input.sync="searchInput"              
            >
          <template v-slot:item="data">
            <v-list-item @click="toggleAutocomplete(data.item, 'prestador_id');" :class="formData.prestador_id.includes(data.item.id)? 'primary--text v-list-item--active': ''">
              <v-list-item-content>
                <v-list-item-title>{{data.item.prest_nome}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
        </template>
          <template v-slot:selection="data">
            <v-chip v-if="data.index < 2" small label class="ma-1" :style="formData.prestador_id.length>1? 'max-width:30%':'max-width:100%'">{{
              data.item.prest_nome
            }}</v-chip>
            <span v-if="data.index == 2" class="ml-2 grey--text caption">
              (+{{
                formData.prestador_id.length == 3
                  ? formData.prestador_id.length - 2 + " outro"
                  : formData.prestador_id.length - 2 + " outros"
              }})
            </span>
          </template>
        </v-autocomplete>
      </v-col>
           <v-col cols="12" sm="6" md="3" class="px-3 py-0">
            <label>Operadoras</label>
            <v-autocomplete
              v-model="formData.operadora_ans_id"
              :items="operadorasFilter"
              item-value="id"
              item-text="oper_nome"
              label="Selecione"
              multiple
              chips
              outlined
              flat
              solo
              dense
              filled
              @input="getIdenficacao(formData)"
              :disabled="operadorasFilter.length==1"
              :search-input.sync="searchInput"
            >
          <template v-slot:item="data">
            <v-list-item @click="toggleAutocomplete(data.item, 'operadora_ans_id')" :class="formData.operadora_ans_id.includes(data.item.id)? 'primary--text v-list-item--active': ''">
              <v-list-item-content>
                <v-list-item-title>{{data.item.oper_nome}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
        </template>
          <template v-slot:selection="data">
            <v-chip v-if="data.index < 2" small label class="ma-1" :style="formData.operadora_ans_id.length>1? 'max-width:30%':'max-width:100%'">{{
              data.item.oper_nome
            }}</v-chip>
            <span v-if="data.index == 2" class="ml-2 grey--text caption">
              (+{{
                formData.operadora_ans_id.length == 3
                  ? formData.operadora_ans_id.length - 2 + " outro"
                  : formData.operadora_ans_id.length - 2 + " outros"
              }})
            </span>
          </template>
        </v-autocomplete>
      </v-col>
          <!-- <v-col class="py-0 px-2" cols="3">
            <label>Identificador</label>
            <v-select
                v-model="formData.identificador_prestador"
                :items="identFilter"
                item-value="id"
                item-text="identificador_prestador"
                :menu-props="{ bottom: true, offsetY: true }"
                flat
                solo
                dense
                outlined
                :disabled="identDis"
            ></v-select>
          </v-col> -->
          <v-col cols="12" sm="6" md="3" class="px-3 py-0">
            <label>Evento</label>
            <v-autocomplete
              v-model="formData.evento_id"
              :items="eventosFilter"
              item-value="id"
              item-text="evento"
              label="Selecione"
              multiple
              chips
              outlined
              flat
              solo
              dense
              filled
              :search-input.sync="searchInput" 
            >
          <template v-slot:item="data">
            <v-list-item @click="toggleAutocomplete(data.item, 'evento_id')" :class="formData.evento_id.includes(data.item.id)? 'primary--text v-list-item--active': ''">
              <v-list-item-content>
                <v-list-item-title>{{data.item.evento}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
        </template>
          <template v-slot:selection="data">
            <v-chip v-if="data.index < 2" small label class="ma-1" :style="formData.evento_id.length>1? 'max-width:30%':'max-width:100%'">{{
              data.item.evento
            }}</v-chip>
            <span v-if="data.index == 2" class="ml-2 grey--text caption">
              (+{{
                formData.evento_id.length == 3
                  ? formData.evento_id.length - 2 + " outro"
                  : formData.evento_id.length - 2 + " outros"
              }})
            </span>
          </template>
        </v-autocomplete>
      </v-col>
          <v-col class="pt-5 px-2 text-right" cols="3">
              <v-spacer></v-spacer>
              <v-btn
                small 
                height="32px"
                color="primary"
                class="px-1 mr-3"
                depressed
                @click="sendFilter()"
                >Filtrar</v-btn>
              <v-btn
                outlined
                small 
                height="32px"
                color="primary"
                class="px-1 ml-1"
                depressed
                @click="clearFilters()"
                >Limpar Filtro</v-btn>
          </v-col>
      </v-row>
      </v-form>
  </v-container>
</template>

<script>
import {mapState, mapActions} from 'vuex'
export default {
    data() {
        return{
            formData: {
                com_intercorrencia: false,
                prestador_id: [],
                operadora_ans_id: [],
                qtd_dias: null,
                evento_id: [],
                data_entre: null,
                data_ate: null,
                identificador_prestador: null
            },
            dtI: false,
            dateI:null,
            dateIFormatted: null,
            dtF: false,
            dateF: null,
            dateFFormatted: null,
            prestadoresFilter: [],
            operadorasFilter: [],
            statusFilter: [{
                id: null,
                descricao: 'Selecione',
                color: null,
            },{
                id: 3,
                descricao: "D3",
                color: "#32B88B",
            },{
                id: 5,
                descricao: "D5",
                color: "#B2B842",
            },{
                id: 6,
                descricao: "D>5",
                color: "#4A4A4A",
            }],
            identFilter: [],
            eventosFilter: [],
            identDis: true,
            searchInput: null
        }
    },
    computed: {
        ...mapState({
            formRules: state => state.formRules
        }),
    },  
    watch: {
        prestadores:{
            deep: true,
            handler(val){
                this.prestadoresFilter = Array.from(val)
                if (val && val.length==1) {
                    this.formData.prestador_id = [val[0].id]
                } 
            }
        },
        operadoras:{
            deep: true,
            handler(val){
                this.operadorasFilter = Array.from(val)
                if (val && val.length==1) {
                    this.formData.operadora_ans_id = [val[0].id]
                } 
            }
        },
        dateF(val){
          if (!val) {
            this.dateFFormatted = null
          } else {
            if (!!this.dateI && Date.parse(this.dateI) > Date.parse(val)){
              this.dateI = val
            }
            this.dateFFormatted = this.formatDate(val)
          }
        },
        dateFFormatted(val){
          this.formData.data_ate = this.parseDate(val)
        },
        dateI(val){
          if (!val) {
            this.dateIFormatted = null
          } else {
            if (!!this.dateF && Date.parse(this.dateF) < Date.parse(val)){
              this.dateF = val
            }
            this.dateIFormatted = this.formatDate(val)
          }
        },
        dateIFormatted(val){
          this.formData.data_entre = this.parseDate(val)
        },
    },
    mounted() {
        let stateFilter = this.$store.state.recebiveis.pagamentosEmProcessamento
        this.getEventos().then(resp => { 
            let eventosFiltrados = resp.filter(ele => ele.id >= 200 && ele.id < 500 || ele.id == 3)
            
            this.eventoList = eventosFiltrados

            this.filterEvento()
        })
        this.filterIdent()
        this.formData.grupo_economico = this.$store.state.permissions.grupoEconomico
        this.formData = stateFilter? {...stateFilter} : this.formData
        let clear = stateFilter? false : true
        this.filterList(this.formData, clear)
    },
    methods: {
        ...mapActions("recebiveis", [
          "getEventos",
        ]),
        changePrestador() {
           let opts = {
              grupoEconomico: this.formData.grupo_economico,
              modulo_operadora: "recebiveis",
              prestador_ids: this.formData.prestador_id
            }
           this.$store.dispatch("permissions/getOperadoras", opts)
          //  .then(() => this.getIdenficacao(this.formData))
        },
        clearFilters(){
            this.com_intercorrencia = false
            this.formData.operadora_ans_id = []
            this.formData.qtd_dias = null
            this.formData.evento_id = []
            this.formData.data_ate = null
            this.formData.data_entre = null
            this.dateI = null
            this.dateF = null
            this.dateIFormatted = null
            this.dateFFormatted = null
            this.identDis = true
            if (this.prestadoresFilter.length>1) 
            this.formData.prestador_id = []
            if (this.operadorasFilter.length>1) 
            this.formData.operadora_ans_id = []
            this.filterList(this.formData, 1, true)
        },
        filterEvento() {
          let status = this.formData.status
          if(status != null) {
            this.eventosFilter = [...this.eventoList].filter(evento => evento.erro==status)
            // this.eventosFilter.unshift({id: null, evento: "Selecione" })
          } else {
            this.eventosFilter = [...this.eventoList]
            // this.eventosFilter.unshift({id: null, evento: "Selecione" })
          }
          this.formData.evento_id = [];
        },
        getIdenficacao(formData) {
          let {prestador_id,  operadora_ans_id} = formData
            if (formData.prestador_id.length && formData.operadora_ans_id.length) {
                let obj = {
                    query: [{
                    Modulo: "Recebiveis",
                    Acao: "getidentificacaooperadora",
                    Payload: {
                        grupo_economico: this.grupoEconomico,
                        prestador_id,
                        operadora_ans_id,
                        modulo: "recebiveis"
                    }
                    }],
                }
                this.$store.dispatch('request/doRequest', obj).then((response) => {
                    if (!response || response.isAxiosError || response.error) {
                    this.$store.commit("hideLoader")
                    return
                    }
                    this.filterIdent(response.dados)
                })
            } else {
                this.formData.identificador_prestador = null
                this.identDis = true
            }
        },
        filterIdent(val) {
            if (this.formData.prestador_id.length && this.formData.operadora_ans_id.length && val.length) {
                this.identFilter = val
                this.identFilter.unshift({id: null, identificador_prestador: "Selecione" })
                this.identDis = false
            } else {
                this.identFilter = []
                this.identDis = true
            }
            this.formData.identificador_prestador = null
        },
        sendFilter(){
          if(this.$refs.filterPgtosEmProcessamentoForm.validate()){
              if(!this.formData.data_ate && this.formData.data_entre) {
                this.dateF = this.formData.data_entre
                this.formData.data_ate = this.formData.data_entre
            }
            if(this.formData.identificador_prestador){
                this.formData.identificador_prestador = this.identFilter.find(el=>el.id == this.formData.identificador_prestador).identificador_prestador
            }
            this.filterList(this.formData, 1, false)
          }
        },
        toggleAutocomplete(item, campo) {
          this.searchInput=null
          let index = this.formData[campo].indexOf(item.id)
          //  index > -1  está excluindo a operadora
          if (index > -1) {
            this.formData[campo].splice(index, 1)
          } else {
            //  index < 0  está adicionando a operadora
              this.formData[campo].push(item.id)
          }
          if(campo =="prestador_id") 
            this.changePrestador()

          if(campo =="operadora_ans_id") 
            this.getIdenficacao(this.formData)

          this.$nextTick()
          return
        },
    },
    props: {
        prestadores: Array,
        operadoras: Array,
        filterList: Function,
        formatDate: Function,
        parseDate: Function,
        grupoEconomico: Number
    }
}
</script>

<style>
.v-text-field--filled.v-input--dense.v-text-field--single-line .v-label, .v-text-field--full-width.v-input--dense.v-text-field--single-line .v-label {
    top: 7px;
}
</style>